const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getListCategory({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-category?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getMoreRateResponse({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/rate-response/quitionnaire/${id}/rate-responses`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClassStudent({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template-student/classrooms`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClass({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-class?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClassAdd({ commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-class/classrooms`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCategoryStudent({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-category-student?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListTemplateStudent({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template-student?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListResultStudent({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-student?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListResultStudentDetailByID({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-student/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClassByID({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-class/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClassComprasByID({ commit }, { id, classId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-class/${id}/class?classroomIds=${classId ? classId : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListInterClass({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-class/${id}/classrooms`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCourseScore({ commit }, { id, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-class/${id}/course?courseIds=${courseId ? courseId : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListResultListStudentDetailByID({ commit }, { id, search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-student/${id}/students?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getChartResultStudentAnalitic({ commit }, { id, studentId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-student/${id}/student/${studentId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListRateResponse({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/rate-response?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getQuizListTeacher({ commit }, { classroomId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-quitionnaire/classroom/${classroomId}/course/${courseId}/teachers`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getQuizListStudent({ commit }, { classroomId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-quitionnaire/classroom/${classroomId}/course/${courseId}/students`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListQuiz({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-quitionnaire?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCategoryById({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-category/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListStudent({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${id}/student-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCategoryStudentById({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-category-student/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListTemplateStudentById({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template-student/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getQuizStudentTeacher({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/quitionnaire/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListQuizById({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-quitionnaire/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getRateResponse({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/rate-response/quitionnaire/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCategoryTemplate({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template/category?analyticalTemplateId=${id ? id : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCategoryTemplateStudent({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template-student/category?analyticalTemplateStudentId=${id ? id : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListCategoryTemplateQuiz({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-quitionnaire/template/${id ? id : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListTemplate({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template?search=${search ? search : ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListTemplateById({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/analytical-template/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  download({ commit }, { analyticalQuitionnaireId }) {
    let url;
    url = `/api/rate-response/quitionnaire/${analyticalQuitionnaireId}/export`;
    return window.axios.get(`${url}`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  downloadStudent({ commit }, { id, studentId }) {
    let url;
    url = `/api/analytical-student/${id}/student/${studentId}/export`;
    return window.axios.get(`${url}`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  createCategory({ commit }, payload) {
    return window.axios.post(`/api/analytical-category`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  createCategoryStudent({ commit }, payload) {
    return window.axios.post(`/api/analytical-category-student`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  fillTeacher({ commit }, payload) {
    let id = payload.analyticalQuitionnaireId;
    return window.axios.post(`/api/quitionnaire/${id}`, payload.payload);
  },
  // eslint-disable-next-line no-unused-vars
  createQuiz({ commit }, payload) {
    return window.axios.post(`/api/analytical-quitionnaire`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  createClassAnalitic({ commit }, payload) {
    return window.axios.post(`/api/analytical-class`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  useTemplateStudent({ commit }, payload) {
    return window.axios.post(`/api/analytical-template-student/${payload.analyticalTemplateStudentId}/use`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateCategory({ commit }, payload) {
    return window.axios.put(`/api/analytical-category/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateCategoryStudent({ commit }, payload) {
    return window.axios.put(`/api/analytical-category-student/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateQuiz({ commit }, payload) {
    return window.axios.put(`/api/analytical-quitionnaire/${payload.analyticalQuitionnaireId}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  deleteCategory({ commit }, payload) {
    return window.axios.delete(`/api/analytical-category/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  createTemplate({ commit }, payload) {
    payload.categories = payload.categories.map(a => a.analyticalCategoryId);
    return window.axios.post(`/api/analytical-template`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  createTemplateStudent({ commit }, payload) {
    payload.categories = payload.categories.map(a => a.analyticalCategoryId);
    return window.axios.post(`/api/analytical-template-student`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateTemplate({ commit }, payload) {
    payload.categories = payload.categories.map(a => a.analyticalCategoryId);
    return window.axios.put(`/api/analytical-template/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateTemplateStudent({ commit }, payload) {
    payload.categories = payload.categories.map(a => a.analyticalCategoryId);
    return window.axios.put(`/api/analytical-template-student/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  deleteTemplate({ commit }, payload) {
    return window.axios.delete(`/api/analytical-template/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  deleteQuiz({ commit }, payload) {
    return window.axios.delete(`/api/analytical-quitionnaire/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  deleteCategoryStudent({ commit }, payload) {
    return window.axios.delete(`/api/analytical-category-student/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  deleteTempalateStudent({ commit }, payload) {
    return window.axios.delete(`/api/analytical-template-student/${payload}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
